import { render } from "./TooltipComponent.vue?vue&type=template&id=1fdea795"
import script from "./TooltipComponent.vue?vue&type=script&lang=js"
export * from "./TooltipComponent.vue?vue&type=script&lang=js"

import "./TooltipComponent.vue?vue&type=style&index=0&id=1fdea795&lang=css"

import exportComponent from "/codebuild/output/src794593303/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/viracocha-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__